/**
 * @module ActionDataPoint
 */

import ElementalDataPoint from './ElementalDataPoint';
import { MessageContext, ElementDetails } from 'owa-actionable-message-v2';
import { DEFAULT_ACTION_ID } from '../constants';

/**
 * @class ActionDataPoint
 */

export default class ActionDataPoint extends ElementalDataPoint {
    /**
     * @private
     * To set action data point properties
     * @param {ElementDetails} [elementDetails] - An element details object
     * @returns Nothing
     */

    private setActionProperties(elementDetails?: ElementDetails): void {
        let actionId = DEFAULT_ACTION_ID;
        if (elementDetails?.id) {
            actionId = elementDetails.id;
        }
        this.setProperty('actionId', actionId);
    }

    /**
     * @constructor
     * To create an instance of Action data point
     * @param {string} eventName - A client event name
     * @param {MessageContext} messageContext - A message context object
     * @param {ElementDetails} [elementDetails] - An element details object
     * @returns An instance of ActionDataPoint
     */

    constructor(
        eventName: string,
        messageContext: MessageContext,
        elementDetails?: ElementDetails
    ) {
        super(eventName, messageContext);
        this.setActionProperties(elementDetails);
    }
}
